import { Skeleton } from "primereact/skeleton";
// TODO: make it more configurable
export const generateFakeRows = (numberRows: any) => {
  return new Array(numberRows)
    .fill(null)
    .map((_, i) => i)
    .map((index) => {
      return (
        <tr key={index}>
          <td colSpan={4}>
            <Skeleton width="100%" height="30px"></Skeleton>
          </td>
        </tr>
      );
    });
};
